function hooks() {
  window.addEventListener('fs-custom-events-product-added-to-cart', (e) => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;
    cartDrawer.refresh(true).then(() => {
      cartDrawer.open();
    });
  });
  window.SerpOptions.registerHook('serp-product-grid', ({products, element}) => {
    console.log('Fast Simon Hooks Initialized');
    const url = new URL(window.location.href);
    const searchQuery = url.searchParams.get('q');
    if (searchQuery && document.querySelector('.search__title')) {
      document.querySelector('.search__title').textContent = `Search results for: '${searchQuery}'`;
    }
    element.querySelectorAll('.fs-results-product-card').forEach((productCard)=>{
      let showProductStatus = 'false' === 'true';
      let showProductShipping = 'false' === 'true';
      if(productCard.querySelector('.product-card-items-wrapper').classList.contains('fs-card-init')) return;
      productCard.querySelector('.product-card-items-wrapper').classList.add('fs-card-init');
      if(productCard.querySelector('.fs-product-status') || productCard.querySelector('.fs-product-shipping')) return;
      let productId = productCard.dataset.productId;
      let productData = products[productId];
      if(productData && !productData.isSoldOut && showProductStatus) {
        let statusDiv = document.createElement('div');
        statusDiv.className = 'fs-product-status';
        statusDiv.textContent = 'In Stock';
        productCard.querySelector('.fs-serp-product-title').insertAdjacentElement('afterend', statusDiv);
      }
      if(productData && productData.isSoldOut && showProductStatus) {
        let statusDiv = document.createElement('div');
        statusDiv.className = 'fs-product-status';
        statusDiv.textContent = 'Sold Out';
        productCard.querySelector('.fs-serp-product-title').insertAdjacentElement('afterend', statusDiv);
      }
      if(productData && productData.isSoldOut) {
        let buttonHolder = productCard.querySelector('.add-to-cart-button-wrapper');
        buttonHolder.innerHTML = `
          <a href="${productData.productURL}" class="fs-sold-out-button">
            Notify Me
          </a>
        `;
      }
      if(showProductShipping) {
        let shippingDiv = document.createElement('div');
        shippingDiv.className = 'fs-product-shipping';
        shippingDiv.textContent = 'Free standard shipping included';
        productCard.querySelector('.fs-serp-info').append(shippingDiv);
      }
      let cartButton = productCard.querySelector('.add-to-cart-button-wrapper');
      let infoContainer = productCard.querySelector('.fs-serp-info');
      if(cartButton) {
        cartButton.remove();
        infoContainer.append(cartButton);
      }
      let reviewCount = productCard.querySelector('.fs-reviews-count');
      if(reviewCount && reviewCount.innerText.trim() === '(0)') {
        reviewCount.closest('.fs-serp-reviews').remove();
      }
      let priceContainer = productCard.querySelector('.price-container');
      let compareContainer = productCard.querySelector('.compare-container');
      if(priceContainer && compareContainer) {
        let newPriceContainer = document.createElement('div');
        newPriceContainer.className = 'card-price-container';
        priceContainer.insertAdjacentElement('afterend', newPriceContainer);
        priceContainer.remove();
        compareContainer.remove();
        newPriceContainer.append(priceContainer);
        newPriceContainer.append(compareContainer);
      }
      if(productData && !productData.isSoldOut && productData.variants.length > 1) {
        let cardButton = productCard.querySelector('.add-to-cart-button.fs-add-to-cart-button.ajax_add_to_cart .add-to-cart-spinner-text-wrapper span');
        if(cardButton) {
          cardButton.innerText = 'Choose Options';
        }
      }
    });
  });
}

// execution here
if (window.SerpOptions) {
  hooks();
} else {
  window.addEventListener('fast-serp-ready', function () {
    hooks();
  });
}